webpackJsonp([3],{

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lib/api.js
// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://www.bainisysstg.com/o365'

// export const CORE_API_ENDPOINT = 'http://localhost:2000/core'
// export const O365_API_ENDPOINT = 'http://localhost:3000/o365'

// export const CORE_API_ENDPOINT = '/roomminister/core'
// export const O365_API_ENDPOINT = '/roomminister/o365'

// export const CORE_API_ENDPOINT = 'http://10.0.10.22:2000/core'
// export const O365_API_ENDPOINT = 'http://10.0.10.22:3000/o365'

var CORE_API_ENDPOINT = '/core';
var O365_API_ENDPOINT = '/o365';

// export const CORE_API_ENDPOINT = 'https://frontend.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://frontend.rmbainisys.com/o365'
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(430);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/lib/auth.js



var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var SERVICE_TOKEN = 'service_token';
var O365_TOKEN = 'o365_token';
var EXPIRES_ON = 'expires_on';
var REFRESH_TOKEN = 'refresh_token';
var SERVICE_TOKEN_EXPIRES = 'service_token_expires_on';
var IS_INTEGRATION = 'isIntegration';
var USER_ID = 'id';
var O365_EXPIRES_ON = 'o365_expires_on';
var USER_EMAIL = 'email';
var TOKEN_EXPIRE = 'token_expire';
var IS_USER_AD = 'isUserActiveDirectory';
var TIME_ZONE = 'timeZone';
var SERVICE = 'service';
var FIRSTNAME = 'firstName';
var LASTNAME = 'lastName';

function getCookie(key) {
    return js_cookie_default.a.get(key);
}

function setCookie(key, value) {
    js_cookie_default.a.set(key, value);
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD);
}

function getAccessToken() {
    return getCookie(SERVICE_TOKEN);
}

function getO365Token() {
    return getCookie(O365_TOKEN);
}

function getIsIntegration() {
    return getCookie(IS_INTEGRATION);
}

function getServiceType() {
    return getCookie(SERVICE);
}

function getAllToken() {
    if (!getCookie(SERVICE_TOKEN)) return {};
    return {
        access_token: getCookie(SERVICE_TOKEN),
        expires_on: getCookie(SERVICE_TOKEN_EXPIRES)
    };
}
function getToken() {
    if (!getCookie(SERVICE_TOKEN)) return {};
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION),
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN)
    };
}
function setToken(_ref) {
    var token = _ref.token,
        expires_on = _ref.expires_on;

    setCookie(SERVICE_TOKEN, token);
    setCookie(SERVICE_TOKEN_EXPIRES, expires_on);
}

function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
}

function getUserInfo(access_token) {
    if (!access_token) return {};

    // const {
    // //   iat,
    // //   exp,
    // //   appid,
    // //   name,
    // //   unique_name: email
    // } = jwt.decode(access_token)

    return {
        //   iat,
        //   exp,
        //   appid,
        //   name,
        //   email
    };
}

function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN);
}
function getUserEmail() {
    return getCookie(USER_EMAIL);
}
function getUserId() {
    return getCookie(USER_ID);
}

function getTimeZone() {
    return getCookie(TIME_ZONE);
}

function getUserInformation() {
    var firstName = getCookie(FIRSTNAME),
        lastName = getCookie(LASTNAME),
        email = getCookie(USER_EMAIL),
        service = getCookie(SERVICE),
        id = getCookie(USER_ID);
    return { firstName: firstName, lastName: lastName, email: email, service: service, id: id };
}

function getTokenExpire() {
    return getCookie(TOKEN_EXPIRE);
}
function setBSRSToken(bsrsToken) {
    var isIntegration = bsrsToken.isIntegration,
        token = bsrsToken.token,
        id = bsrsToken.id,
        o365_token = bsrsToken.o365_token,
        o365_token_expire_on = bsrsToken.o365_token_expire_on,
        email = bsrsToken.email,
        isUserActiveDirectory = bsrsToken.isUserActiveDirectory,
        timeZone = bsrsToken.timeZone,
        firstName = bsrsToken.firstName,
        lastName = bsrsToken.lastName,
        service = bsrsToken.service;

    setCookie(BSRS_ACCESS_TOKEN, token);
    // setCookie(SERVICE_TOKEN, access_token)
    // setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
    setCookie(IS_INTEGRATION, isIntegration);
    setCookie(USER_ID, id);
    setCookie(O365_TOKEN, o365_token ? o365_token : "");
    setCookie(O365_EXPIRES_ON, o365_token_expire_on ? o365_token_expire_on : "");
    setCookie(USER_EMAIL, email ? email : "");
    // setCookie(TOKEN_EXPIRE, token_expire)
    setCookie(IS_USER_AD, isUserActiveDirectory);
    setCookie(TIME_ZONE, timeZone);
    setCookie(FIRSTNAME, firstName);
    setCookie(LASTNAME, lastName);
    setCookie(SERVICE, service);
}
function setUserInfo(_ref2) {
    var firstName = _ref2.firstName,
        lastName = _ref2.lastName;

    setCookie(FIRSTNAME, firstName);
    setCookie(LASTNAME, lastName);
}
function setRefreshToken(res) {
    if (res.value) {
        var _res$value = res.value,
            serviceToken = _res$value.serviceToken,
            token = _res$value.token,
            user = _res$value.user;

        var o365_token = null,
            o365_token_expire_on = null;
        if (user.token) {
            user.token.forEach(function (token) {
                var _token$data = token.data,
                    access_token = _token$data.access_token,
                    expires_on = _token$data.expires_on;

                o365_token = access_token;
                o365_token_expire_on = expires_on;
            });
        }
        var access_token = serviceToken.access_token,
            expires_on = serviceToken.expires_on;

        var token_expire = expires_on > o365_token_expire_on ? o365_token_expire_on : expires_on;
        // let bsrsToken = { access_token, token, o365_token, token_expire }
        setCookie(SERVICE_TOKEN, access_token);
        setCookie(BSRS_ACCESS_TOKEN, token);
        setCookie(O365_TOKEN, o365_token ? o365_token : "");
        setCookie(TOKEN_EXPIRE, token_expire);
    }
}

function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    removeCookie(SERVICE_TOKEN);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
    removeCookie(O365_TOKEN);
    removeCookie(O365_EXPIRES_ON);
    removeCookie(USER_EMAIL);
    removeCookie(TOKEN_EXPIRE);
    removeCookie(IS_USER_AD);
    removeCookie(TIME_ZONE);
    removeCookie(SERVICE);
    removeCookie(FIRSTNAME);
    removeCookie(LASTNAME);
}
// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 36 modules
var react_router_dom_es = __webpack_require__(84);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(129);

// CONCATENATED MODULE: ./src/lib/withAuthCheck.js




// import { getIsLoggedIn } from 'Features/auth/selectors'

var withAuthCheck_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["b" /* Redirect */], { to: '/login' });
};
var withAuthCheck_withAuthCheck = function withAuthCheck(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheck = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheck'), Object(es["connect"])(function (state) {
    return {
      // isLoggedIn: getIsLoggedIn(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn;
  }, withAuthCheck_withAuthCheck, Object(Recompose["d" /* renderComponent */])(withAuthCheck_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return O365_API_ENDPOINT; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getIsUserActiveDirectory; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getAccessToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getO365Token; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getIsIntegration; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getServiceType; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getAllToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clearToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return getBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUserEmail; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUserId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return getTimeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUserInformation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return getTokenExpire; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return setRefreshToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clearBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });
/* unused concated harmony import withAuthCheck */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheck; });





/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_LOAD_ALL_SERVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_LOAD_ALL_SERVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_LOAD_ALL_SERVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_CHANGE_PREPARE_TO_SEND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_CHANGE_PREPARE_TO_SEND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_CHANGE_PREPARE_TO_SEND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_CHANGE_SEND_TO_DONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_CHANGE_SEND_TO_DONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_CHANGE_SEND_TO_DONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CHANGE_TO_REJECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CHANGE_TO_REJECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CHANGE_TO_REJECT_FAILURE; });
var LOGOUT = 'LOGOUT';
var SET_ERROR = 'SET_ERROR';

var CORE_LOAD_ALL_SERVICE_REQUEST = 'CORE_LOAD_ALL_SERVICE_REQUEST';
var CORE_LOAD_ALL_SERVICE_SUCCESS = 'CORE_LOAD_ALL_SERVICE_SUCCESS';
var CORE_LOAD_ALL_SERVICE_FAILURE = 'CORE_LOAD_ALL_SERVICE_FAILURE';

var CORE_CHANGE_PREPARE_TO_SEND_REQUEST = 'CORE_CHANGE_PREPARE_TO_SEND_REQUEST';
var CORE_CHANGE_PREPARE_TO_SEND_SUCCESS = 'CORE_CHANGE_PREPARE_TO_SEND_SUCCESS';
var CORE_CHANGE_PREPARE_TO_SEND_FAILURE = 'CORE_CHANGE_PREPARE_TO_SEND_FAILURE';

var CORE_CHANGE_SEND_TO_DONE_REQUEST = 'CORE_CHANGE_SEND_TO_DONE_REQUEST';
var CORE_CHANGE_SEND_TO_DONE_SUCCESS = 'CORE_CHANGE_SEND_TO_DONE_SUCCESS';
var CORE_CHANGE_SEND_TO_DONE_FAILURE = 'CORE_CHANGE_SEND_TO_DONE_FAILURE';

var CORE_CHANGE_TO_REJECT_REQUEST = 'CORE_CHANGE_TO_REJECT_REQUEST';
var CORE_CHANGE_TO_REJECT_SUCCESS = 'CORE_CHANGE_TO_REJECT_SUCCESS';
var CORE_CHANGE_TO_REJECT_FAILURE = 'CORE_CHANGE_TO_REJECT_FAILURE';

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 502, 503];

function getAction(type, action, state, res) {
	return new Promise(function (resolve, reject) {
		if (!res) return resolve({ type: type });

		if (resStatusError.includes(res.status)) {
			if (res.status === 422) {
				return res.json().then(function (json) {
					var message = "";
					for (var key in json) {
						if (json.hasOwnProperty(key)) {
							var element = json[key];
							for (var k in element) {
								if (element.hasOwnProperty(k)) {
									var ele = element[k];
									message += "" + ele.msg;
									if (ele.param) message += " Param : " + ele.param + " ";
									message += "\n";
								}
							}
						}
					}

					return reject({
						statusText: res.statusText, data: {
							code: res.status.toString(),
							message: message
						}
					});
				});
			} else if (res.status === 404) {
				return reject({
					statusText: 404, data: {
						code: "404",
						message: "404 (Not Found)"
					}
				});
			} else {
				return res.json().then(function (data) {
					return reject({ statusText: res.statusText, data: data });
				});
			}
		}

		if ((typeof type === "undefined" ? "undefined" : _typeof(type)) === 'object') {
			if (type.payload) {
				var payload = type.payload(action, state, res);
				if (typeof payload.then === 'function') {
					//promise
					return payload.then(function (data) {
						return resolve({ type: type.type, payload: data });
					});
				} else {
					return resolve({ type: type.type, payload: payload });
				}
			}

			return resolve({ type: type.type });
		}

		res.json().then(function (payload) {
			return resolve({ type: type, payload: payload });
		});
	});
}

/* harmony default export */ var api = (function (_ref) {
	var getState = _ref.getState;
	return function (next) {
		return function (action) {
			if (_typeof(action[CALL_API]) !== 'object') return next(action);

			var _action$CALL_API = action[CALL_API],
			    endpoint = _action$CALL_API.endpoint,
			    _action$CALL_API$meth = _action$CALL_API.method,
			    method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
			    headers = _action$CALL_API.headers,
			    body = _action$CALL_API.body,
			    types = _action$CALL_API.types;

			var _types = _slicedToArray(types, 3),
			    request = _types[0],
			    success = _types[1],
			    failure = _types[2];

			var callBack = success.callBack;

			var state = getState();

			getAction(request, action, state).then(function (action) {
				return next(action);
			});

			if (callBack) {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					callBack(action);
					next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true });
				});
			} else {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true });
				});
			}
		};
	};
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(426);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/lib/index.js + 4 modules
var lib = __webpack_require__(130);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            // const isO365 = entry.types[0].startsWith("O365")
            var expire = Object(lib["d" /* getTokenExpire */])();
            // if(isO365){ 
            //     const token = getAccessToken()

            //     if(!token) return next(action)

            // const { expires_on } = getAllToken()
            var currentTime = moment_timezone_default()().tz(Object(lib["c" /* getTimeZone */])());
            var duration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(expire).diff(currentTime));
            var minutes = duration.asMinutes();

            if (minutes < 5) {
                fetch(lib["a" /* CORE_API_ENDPOINT */] + '/user/newtoken', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + Object(lib["b" /* getBSRSToken */])()
                    }
                }).then(function (res) {
                    return res.json();
                }).then(function (json) {
                    return Object(lib["e" /* setRefreshToken */])(json);
                }).then(function () {
                    return next(action);
                });
            } else {
                next(action);
            }
            // }else{
            //     next(action)
            // }  
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
  return function (next) {
    return function (action) {
      var entry = action[CALL_API];

      if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

      var token = void 0;
      var entryType = entry.types[0];

      if (entryType.startsWith("CORE") || entry.types[0].startsWith("O365") || entry.types[0].startsWith("SERVICE")) {
        token = Object(lib["b" /* getBSRSToken */])();
      }
      // else if (entry.types[0].startsWith("SERVICE")) {
      //   token = getO365Token()
      // }

      if (!token) return next(action);

      entry.headers = _extends({}, entry.headers, { 'Authorization': 'Bearer ' + token });

      next(action);
    };
  };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(402);


/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(410);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 36 modules
var es = __webpack_require__(84);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/src/index.js
var src = __webpack_require__(417);
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new src["schema"].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(423);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(129);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(83);

// CONCATENATED MODULE: ./src/features/ui/selectors.js
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getHasBSRSLoginFail(state) {
    return state.ui.hasBSRSLoginFail === true;
}

function getErrorMessage(state) {
    return state.ui.errorMessage;
}

function getErrorCode(state) {
    return state.ui.errorCode;
}

function getUiMessage(state) {
    return state.ui;
}

function getError(state) {
    return state.ui.error;
}
// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(131);

// CONCATENATED MODULE: ./src/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var src_error = ({
	errorMessage: errorMessage
});
// CONCATENATED MODULE: ./src/features/ui/actions.js





function setError(hasError) {
	var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var defaultError = {
		code: "00010000",
		message: src_error.errorMessage["00010000"]
	};

	if (typeof error === 'string' && error in src_error.errorMessage) {
		defaultError = {
			code: error,
			message: src_error.errorMessage[error]
		};
	} else if (error !== null && error.code !== undefined && error.message !== undefined) {
		defaultError = error;
	} else if (error === null || hasError === false) {
		defaultError = null;
	}

	return {
		type: types["m" /* SET_ERROR */],
		hasError: hasError,
		error: defaultError
	};
}
// CONCATENATED MODULE: ./src/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ErrorMessageDialog_ErrorMessage = function (_React$Component) {
	_inherits(ErrorMessage, _React$Component);

	function ErrorMessage() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ErrorMessage);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
			_this.setState({ open: false });
			_this.props.clearError();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ErrorMessage, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProp) {
			this.setState({ open: nextProp.hasError });
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				dist_es["h" /* Modal */],
				{ open: this.state.open, onClose: this.close, size: 'small' },
				react_default.a.createElement(
					dist_es["h" /* Modal */].Content,
					{ style: { height: 'auto' } },
					react_default.a.createElement(
						'div',
						{ className: 'errormessage' },
						react_default.a.createElement(
							'div',
							{ className: 'contenterror' },
							react_default.a.createElement(
								'div',
								{ className: 'content-text' },
								react_default.a.createElement(
									'div',
									{ className: 'close', onClick: this.close },
									react_default.a.createElement(dist_es["g" /* Image */], { src: '/assets/images/icon-cross-red.png' })
								),
								react_default.a.createElement(
									'h2',
									null,
									'Something went wrong.'
								),
								this.props.hasError && this.props.error != null && this.props.error.code !== undefined && this.props.error.message !== undefined ? react_default.a.createElement(
									'p',
									null,
									this.props.error.message
								) : react_default.a.createElement(
									'p',
									null,
									'Something went wrong.'
								)
							)
						)
					)
				)
			);
		}
	}]);

	return ErrorMessage;
}(react_default.a.Component);

/* harmony default export */ var ErrorMessageDialog = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state, props) {
	return {
		hasError: getHasError(state),
		error: getError(state)
	};
}, function (dispatch) {
	return {
		clearError: function clearError() {
			dispatch(setError(false));
		}
	};
}))(ErrorMessageDialog_ErrorMessage));
// CONCATENATED MODULE: ./src/features/ui/components/Loading.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Loading_LoadingComponent = function LoadingComponent(props) {
	return props.isLoading ? react_default.a.createElement(
		dist_es["c" /* Dimmer */],
		{ active: true },
		react_default.a.createElement(dist_es["g" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
	) : "";
};

/* harmony default export */ var components_Loading = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state) {
	return {
		isLoading: getIsLoading(state)
	};
}), Object(Recompose["f" /* withProps */])(function (props) {
	return _extends({}, props);
}))(Loading_LoadingComponent));
// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var lib = __webpack_require__(691);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/features/ui/components/Loadable.js
var Loadable__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Loadable_Loading = function Loading() {
    return react_default.a.createElement(
        dist_es["c" /* Dimmer */],
        { active: true },
        react_default.a.createElement(dist_es["g" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
    );
};

/* harmony default export */ var Loadable = (function (opts) {
    return lib_default()(Loadable__extends({
        loading: Loadable_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 4 modules
var src_lib = __webpack_require__(130);

// CONCATENATED MODULE: ./src/lib/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Auth = {
	isAuthenticated: function isAuthenticated() {
		// const bsrsToken = getBSRSToken()
		// // const serviceToken = getAccessToken()

		// return !!bsrsToken /*&& !!serviceToken*/
		return true;
	},
	isIntegration: function isIntegration() {
		// const o365Token = getO365Token()
		// const isIntegration = getIsIntegration()
		// return !!isIntegration
		return true;
	}
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']);

	return react_default.a.createElement(es["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/login' });
			}

			if (Auth.isIntegration() === false && props.match.url !== "/integration") {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/integration' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/' });
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(es["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};


// CONCATENATED MODULE: ./src/features/ui/components/Routes.js





var AsyncHome = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1219));
    }
});

var AsyncFilter = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1220));
    }
});

var AsyncNotFound = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1221));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        es["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/', component: AsyncHome }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/filter', component: AsyncFilter }),
        react_default.a.createElement(routePermission_PublicRoute, { component: AsyncNotFound })
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/App.js

// import Header from './Header'
// import Breadcrumb from './Breadcrumb'

// import Footer from './Footer'


/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
            dist_es["b" /* Container */],
            null,
            react_default.a.createElement(Routes, null)
        )
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js








var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
	return react_default.a.createElement(
		react_redux_es["Provider"],
		{ store: store },
		react_default.a.createElement(
			'div',
			null,
			react_default.a.createElement(
				es["a" /* BrowserRouter */],
				null,
				react_default.a.createElement(App, null)
			),
			react_default.a.createElement(ErrorMessageDialog, null),
			react_default.a.createElement(components_Loading, null)
		)
	);
});

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(424);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(69);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var lib = __webpack_require__(425);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(392);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 225 modules
var redux_form_es = __webpack_require__(432);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var reapop_lib = __webpack_require__(437);
var reapop_lib_default = /*#__PURE__*/__webpack_require__.n(reapop_lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(131);

// CONCATENATED MODULE: ./src/reducers/services.js

var requestState = 'request';

/* harmony default export */ var reducers_services = ({
  services: function services() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["k" /* CORE_LOAD_ALL_SERVICE_REQUEST */]:
        return [];
      case types["l" /* CORE_LOAD_ALL_SERVICE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/ui/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var reducer_initialState = {
	hasError: false,
	isLoading: false,
	error: null
};
/* harmony default export */ var reducer = (function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
	var action = arguments[1];


	switch (action.type) {
		case types["k" /* CORE_LOAD_ALL_SERVICE_REQUEST */]:
		case types["b" /* CORE_CHANGE_PREPARE_TO_SEND_REQUEST */]:
			return _extends({}, state, {
				isLoading: true,
				hasError: false,
				error: null
			});
		case types["l" /* CORE_LOAD_ALL_SERVICE_SUCCESS */]:
		case types["c" /* CORE_CHANGE_PREPARE_TO_SEND_SUCCESS */]:
			return _extends({}, state, {
				isLoading: false,
				hasError: false,
				error: null
			});

		case types["j" /* CORE_LOAD_ALL_SERVICE_FAILURE */]:
		case types["a" /* CORE_CHANGE_PREPARE_TO_SEND_FAILURE */]:
			var returnData = _extends({}, state, {
				isLoading: false,
				hasError: true,
				error: action.payload.data
			});
			return returnData;

		case types["m" /* SET_ERROR */]:
			return _extends({}, state, {
				hasError: action.hasError,
				error: action.error
			});
		default:
			return state;
	}
});
// CONCATENATED MODULE: ./src/reducers.js






/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    notifications: Object(reapop_lib["reducer"])(),
    services: reducers_services.services,
    ui: reducer
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], lib_default.a];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ })

},[401]);


// WEBPACK FOOTER //
// app.35aac7ff02797625538d.js